import * as apiLib from './api';

export const listDonation = async (payload: {
  placeId: string,
  donationNm?: string | null,
  donationDesc?: string | null,
  page: number,
  limit: number,
  accessToken: string,
}) => {
  try {
    const data = { ...payload };

    const result = await apiLib.fetchArchiveApi('/donation/list', data);

    if (result.resultFlag) {
      return result;
    } else {
      throw Object.assign(new Error('listDonation error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};

export const listDonationOfDonor = async (payload: { placeId: string, keyword?: string, accessToken: string }) => {
  try {
    const data = { ...payload };

    const result = await apiLib.fetchArchiveApi('/donation/select-list', data);

    if (result.resultFlag) {
      return result.donorList;
    } else {
      throw Object.assign(new Error('listDonationOfDonor error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};

export const detailDonation = async payload => {
  try {
    const data = {
      ...payload,
    };

    const result = await apiLib.fetchArchiveApi('/donation/detail', data);

    if (result.resultFlag) {
      return result.donationInfo;
    } else {
      throw Object.assign(new Error('donation detail Api Error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};

export const addDonation = async payload => {
  try {
    const data = {
      ...payload,
    };

    const result = await apiLib.fetchArchiveApi('/donation/add', data);

    if (result.resultFlag) {
      return true;
    } else {
      throw Object.assign(new Error('donation Add Api Error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};

export const updateDonation = async payload => {
  try {
    const data = {
      ...payload,
    };

    const result = await apiLib.fetchArchiveApi('/donation/edit', data);

    if (result.resultFlag) {
      return true;
    } else {
      throw Object.assign(new Error('donation update Api Error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};

export const removeDonation = async payload => {
  try {
    const data = {
      ...payload,
    };

    const result = await apiLib.fetchArchiveApi('/donation/remove', data);

    if (result.resultFlag) {
      return true;
    } else {
      throw Object.assign(new Error('donation Remove Api Error'), { status: 401, errorType: result.errorType });
    }
  } catch (err) {
    throw err;
  }
};
